import styled from "styled-components";
import { intenseBlue } from "../../styles/colors";

const HeaderTitle = styled.h1`
  color: ${intenseBlue};
  font-size: 2.3rem;
`;

export default HeaderTitle;
